import Swal from "sweetalert2";
import axios from "../../axios";
import { ADD_SERIES, DELETE_SERIES, GET_SERIES, UPDATE_SERIES } from "../types";
import { setAlert } from "./alert";
import { getErrorMessage } from "../../helpers/ErrorMessage";

// ─── Helper: show success alert ──────────────────────────────────────────────
const showSuccess = (message) =>
  Swal.fire({ title: "Success!", text: message, icon: "success" });

// ─── Helper: show error alert ────────────────────────────────────────────────
const showError = (message) =>
  Swal.fire({ title: "Error!", text: message || "An unexpected error occurred", icon: "error" });

// ─── Helper: show warning alert ──────────────────────────────────────────────
const showWarning = (message) =>
  Swal.fire({ title: "Warning!", text: message, icon: "warning" });

export const addSeries = (data) => async (dispatch) => {
  try {
    const res = await axios.post("series/add", data, {
      headers: { "Content-Type": "application/json" },
    });

    if (res.data.code === 1) {
      dispatch({ type: ADD_SERIES, payload: res.data.data });
      showSuccess(res.data.message);
      dispatch(setAlert(res.data.message, "success"));
    } else {
      showError(res.data.message);
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    const errorMessage = getErrorMessage(err.response?.data);
    showError(errorMessage);
    dispatch(setAlert(errorMessage, "danger"));
  }
};

// ─── GET ALL ─────────────────────────────────────────────────────────────────
export const getSeries = (pageOrParams) => async (dispatch) => {
  try {
    const params = typeof pageOrParams === "object" ? pageOrParams : {};
    if (typeof pageOrParams !== "object" && pageOrParams !== undefined && pageOrParams !== null) {
      params.page = pageOrParams;
    }
    const res = await axios.get("series/all", { params });
    if (res.data.code === 1) {
      dispatch({ type: GET_SERIES, payload: res.data });
    }
  } catch (err) {
    console.error("getSeries error:", err);
  }
};


export const updateSeries = (data) => async (dispatch) => {
  try {
    const res = await axios.post("series/update", data, {
      headers: { "Content-Type": "application/json" },
    });

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_SERIES, payload: res.data.data });
      showSuccess(res.data.message);
      dispatch(setAlert(res.data.message, "success"));
    } else {
      showWarning(res.data.message);
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    const errorMessage = getErrorMessage(err.response?.data);
    showError(errorMessage);
    dispatch(setAlert(errorMessage, "danger"));
  }
};

// ─── DELETE ──────────────────────────────────────────────────────────────────
export const deleteSeries = (id) => async (dispatch) => {
  if (!id) {
    dispatch(setAlert("Please select a record to delete", "warning"));
    return false;
  }

  try {
    const res = await axios.post(`series/delete/${id}`);

    if (res.data.code === 1) {
      dispatch({ type: DELETE_SERIES, payload: { id } });
      showSuccess(res.data.message);
      dispatch(setAlert(res.data.message, "success"));
    } else {
      showError(res.data.message);
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    const errorMessage = getErrorMessage(err.response?.data);
    showError(errorMessage);
    dispatch(setAlert(errorMessage, "danger"));
  }
};